<div class="px-6 pt-5">
  <div class="mb-4 flex items-center gap-2">
    <div class="w-fit">
      <lib-avatars [persons]="[patientAvatar()]" [size]="44" [fontSize]="16" />
    </div>
    <div class="flex flex-1 items-center justify-between">
      @if (patient(); as patient) {
        <div class="flex flex-col items-start justify-center gap-1">
          <h2 class="typo-h3-semibold">{{ patient | fullName }}</h2>
          <h5 class="typo-h6-light text-text-secondary">
            {{ patient.birthDate ?? '' | date }}
            {{ 'health_history_patient_age' | translate: { input1: (patient.birthDate ?? '' | age) } }}
          </h5>
        </div>
      }
    </div>
  </div>
  <div class="flex w-full justify-between gap-6">
    <lib-health-history-patient-details-item
      [icon]="'px-24-phone'"
      [displayText]="patient().mobilePhone ?? '-'"
    ></lib-health-history-patient-details-item>
    <lib-health-history-patient-details-item
      [icon]="'px-24-home'"
      [displayText]="patient().homePhone ?? '-'"
    ></lib-health-history-patient-details-item>
  </div>
</div>
<div class="px-6 pb-6">
  <div class="my-4 min-h-[1px] min-w-full bg-background-disabled"></div>
  <div>
    <div class="mb-1 flex items-center justify-between">
      <h3 class="typo-h6-semibold text-text-primary">{{ 'health_history_patient_secondary_contacts' | translate }}</h3>
    </div>
    @for (contact of patient().contacts; track $index) {
      <div class="typo-h8-semibold mb-1 mt-3 font-medium text-primary-blue">{{ getContactLabelKey(contact.contactType) | translate }}</div>
      <div class="flex w-full items-start justify-between gap-2">
        <h5
          class="typo-h5-medium truncate text-text-light"
          [class.text-text-primary]="contact.contactName"
          [libUiTooltip]="contact.contactName ? nameTooltip : undefined"
          tooltipPosition="bottom"
        >
          {{ contact.contactName || ('health_history_patient_secondary_contact_name' | translate) }}
        </h5>
        <h5 class="typo-h5-medium min-w-26 text-text-light" [class.text-text-tertiary]="contact.phoneNumber">
          {{ (contact.phoneNumber ?? undefined | libPhoneFormat) || ('health_history_patient_secondary_contact_phone' | translate) }}
        </h5>

        <ng-template #nameTooltip>
          <div class="typo-h7-extralight text-text-primary">
            {{ contact.contactName }}
          </div>
        </ng-template>
      </div>
    }
  </div>
</div>
